import { render, staticRenderFns } from "./Page-Cashier.vue?vue&type=template&id=0376c4f1&"
import script from "./Page-Cashier.vue?vue&type=script&lang=js&"
export * from "./Page-Cashier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports